import React from "react";

import GlobalFooter from "../globalFooter/globalFooter";
import { DISPLAY_NAME_FOOTER } from "./constants";

const PageFooter = props => <GlobalFooter {...props} />;

PageFooter.displayName = DISPLAY_NAME_FOOTER;

export default PageFooter;
